import React from 'react';
import { MenuItem, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardArrowDown } from '@material-ui/icons';
import { pxToRem } from '@fluentsms/agentnet-web-components';

interface TextDropdownOption {
  name: string;
  value: string;
}

interface TextDropdownProps {
  value: string;
  options: TextDropdownOption[];
  onChange: (value: string) => void;
  className?: string;
  'data-testid'?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: pxToRem(14),
    fontWeight: 600,
    color: theme.palette.primary.main,
    border: 'none !important',
    '&:before, &:after': {
      display: 'none !important',
    },
    '&.MuiInput-underline:before, &.MuiInput-underline:after': {
      display: 'none !important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
    '& .MuiInput-input': {
      border: 'none',
    },
    '& .MuiSelect-root': {
      display: 'inline-flex',
      alignItems: 'center',
    },
    '& .MuiSelect-select': {
      padding: '10px 0 10px 8px',
      paddingRight: '24px !important',
      backgroundColor: 'transparent',
      color: theme.palette.primary.main,
      fontSize: pxToRem(14),
      fontWeight: 600,
      border: 'none',
      lineHeight: '20px',
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
    '& .MuiSelect-icon': {
      color: theme.palette.primary.main,
      top: `calc(50% - ${theme.spacing(1.5)}px)`,
      right: '-4px',
    },
  },
}));

const TextDropdown: React.FC<TextDropdownProps> = ({ value, options, onChange, className, ...rest }) => {
  const classes = useStyles();

  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value as string)}
      className={`${classes.root} ${className ?? ''}`}
      disableUnderline
      IconComponent={KeyboardArrowDown}
      data-testid={rest['data-testid']}
      MenuProps={{
        getContentAnchorEl: null,
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        transformOrigin: { vertical: 'top', horizontal: 'right' },
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default TextDropdown;
